'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseNavBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseNavBar, _Component);

  function EnterpriseNavBar() {
    (0, _classCallCheck3.default)(this, EnterpriseNavBar);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseNavBar.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseNavBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseNavBar, [{
    key: '_renderItems',
    value: function _renderItems(id) {
      var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!items.length) return null;

      var styles = require('./EnterpriseNavBar.scss');

      var className = styles.link;
      var activeClassName = styles['link--active'];

      return items.map(function (item, index) {
        var type = item.type,
            to = item.to,
            content = item.content;

        var key = 'enterprise-nav-bar-link-' + id + '-' + index;

        switch (type) {
          case 'IndexLink':
            return _react2.default.createElement(
              _reactRouter.IndexLink,
              { key: key, to: to, className: className, activeClassName: activeClassName },
              content
            );
          case 'Link':
            return _react2.default.createElement(
              _reactRouter.Link,
              { key: key, to: to, className: className, activeClassName: activeClassName },
              content
            );
          default:
            return null;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./EnterpriseNavBar.scss');

      var _props = this.props,
          className = _props.className,
          _props$navBar = _props.navBar,
          id = _props$navBar.id,
          items = _props$navBar.items;


      return _react2.default.createElement(
        'nav',
        { className: (0, _classnames2.default)(className, styles.root) },
        this._renderItems(id, items)
      );
    }
  }]);
  return EnterpriseNavBar;
}(_react.Component), _class.propTypes = {
  navBar: _react.PropTypes.object.isRequired,
  className: _react.PropTypes.string
}, _temp);
exports.default = EnterpriseNavBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseNavBar/EnterpriseNavBar.jsx
// module id = 1605
// module chunks = 0